<template>
    <section class="privacy news">
        <div class="container">
            <h3 class="news__title">{{ dataNews.title }}</h3>

            <div class="news__paragraphs">
                <div v-for="(p, index) in dataNews.paragraphs" :key="index" class="news__paragraph">
                    <h4 class="news__header">{{ p.title }}</h4>
                    <div class="news__text" v-html="p.text"></div>   
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "Privacy",
    data() {
        return {
            PRIVACY: '/api/krainaabc/page/privacy-policy?device=www',
            dataNews: [],
        };
    },    
    computed: {
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }  
    },
    methods: {
        getData() {
            axios.get(this.PRIVACY).then((response) => {
                if (response.status === 200) {
                    if(response.data.data) {
                        this.dataNews = response.data.data;
                    }
                }
            });
        },
    },
    mounted() {
        this.getData();

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );
    }
};
</script>